
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "YouTube Ads : créer des vidéos publicitaires qui captivent",
    description:
      "Apprenez à concevoir des publicités YouTube engageantes qui retiennent l’attention et convertissent efficacement votre audience cible. Suivez nos conseils d’expert !",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
